import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom/client';
import Router from './router';
import './styles/styles.css';
var root = ReactDOM.createRoot(document.getElementById('root'));
root.render(_jsx(Router, {}));
